import React from 'react';
import { Button } from './Button';
import { cn } from '../../utils/cn';

export interface NavigationButtonsProps {
  onPrevious?: () => void;
  onNext: () => void;
  previousLabel?: string;
  nextLabel?: string;
  showPrevious?: boolean;
  showNext?: boolean;
  previousDisabled?: boolean;
  nextDisabled?: boolean;
  className?: string;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onPrevious,
  onNext,
  previousLabel = 'Previous',
  nextLabel = 'Next',
  showPrevious = true,
  showNext = true,
  previousDisabled = false,
  nextDisabled = false,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col-reverse sm:flex-row justify-between gap-2.5 sm:gap-3 md:gap-4 pt-3 sm:pt-4',
        className
      )}
    >
      {showPrevious && onPrevious && (
        <Button
          onClick={onPrevious}
          variant="outline"
          size="md"
          fullWidth
          className="sm:w-auto border-secondary-300 bg-white hover:bg-secondary-50 text-secondary-700 hover:text-secondary-900 h-[40px] sm:h-[42px] md:h-[44px] text-sm sm:text-base px-3 sm:px-4 md:px-6 py-2"
          disabled={previousDisabled}
        >
          <div className="flex items-center gap-1.5 sm:gap-2">
            <svg
              className="h-4 w-4 sm:h-5 sm:w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span>{previousLabel}</span>
          </div>
        </Button>
      )}

      {showNext && (
        <Button
          onClick={onNext}
          size="md"
          fullWidth
          className="sm:w-auto bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white border-0 shadow-md hover:shadow-lg h-[40px] sm:h-[42px] md:h-[44px] text-sm sm:text-base px-3 sm:px-4 md:px-6 py-2"
          disabled={nextDisabled}
        >
          <div className="flex items-center gap-1.5 sm:gap-2">
            <span>{nextLabel}</span>
            <svg
              className="h-4 w-4 sm:h-5 sm:w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </Button>
      )}
    </div>
  );
};


